























































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
// Components
import ElementResultsTooltip from '@/components/elements/ElementResultsTooltip.vue';

export type TData = {
  name: string;
  value: number;
  ranges: TRanges;
  unit: string;
  roundedValue: boolean;
};
export type TRanges = {
  base: TRangesMinMax;
  minRange: TRangesMinMax;
  maxRange: TRangesMinMax;
  extremMin: number;
  extremMax: number;
};
export type TRangesMinMax = {
  min: number;
  max: number;
};

@Component({
  components: {
    ElementResultsTooltip,
  },
})
export default class ChartRawGaugeSections extends Vue {
  @Prop({ required: true }) data!: TData;
  @Prop({ default: false }) simple!: boolean;

  // Default colors
  colors: any = {
    neutral: '#e6e8ed',
    goodRange: '#25c090',
    warningRange: '#ffbe13',
    badRange: '#ff5e13',
  };
  valueColor = '';
  sections: any = {
    low: this.colors.neutral,
    mediumLow: this.colors.neutral,
    neutral: this.colors.neutral,
    mediumHigh: this.colors.neutral,
    high: this.colors.neutral,
  };

  getColors() {
    this.clearColors();
    const val = this.data.value;
    switch (true) {
      case val < this.data.ranges.minRange.min:
        this.setColor('low', 'badRange');
        break;
      case val >= this.data.ranges.minRange.min && val < this.data.ranges.base.min:
        this.setColor('mediumLow', 'warningRange');
        break;
      case val >= this.data.ranges.base.min && val <= this.data.ranges.base.max:
        this.setColor('neutral', 'goodRange');
        break;
      case val > this.data.ranges.base.max && val <= this.data.ranges.maxRange.max:
        this.setColor('mediumHigh', 'warningRange');
        break;
      case val > this.data.ranges.maxRange.max:
        this.setColor('high', 'badRange');
        break;
      default:
        this.setColor('neutral', 'neutral');
    }
  }
  setColor(type: string, colorType: string) {
    this.sections[type] = this.colors[colorType];
    this.valueColor = this.colors[colorType];
  }
  clearColors() {
    this.sections = {
      low: this.colors.neutral,
      mediumLow: this.colors.neutral,
      neutral: this.colors.neutral,
      mediumHigh: this.colors.neutral,
      high: this.colors.neutral,
    };
  }

  @Watch('data', { deep: true, immediate: true })
  onDataChange() {
    this.getColors();
  }
}
